import React from 'react';
import { useDispatch } from 'react-redux';

import Button from '@ad-scripts/presentation/components/common/button';
import EmailDomain, { EmailDomainState } from 'src/models/Email/EmailDomain';
import OverflowMenu, {
  OverflowMenuButton,
  OverflowMenuItem,
  usePopoverMenu,
} from 'src/presentation/components/pages/shared/OverflowMenu';
import analytics from '@ad-scripts/lib/analytics';
import emailDomainsResource from 'src/actions/email/emailDomainsResource';

type EmailDomainRowActionsType = {
  item: EmailDomain;
  openEmbedModal: (emailDomain: EmailDomain) => void;
};

const EmailDomainRowActions = ({ item, openEmbedModal }: EmailDomainRowActionsType) => {
  const dispatch = useDispatch();
  const { onClose, ...popoverMenuProps } = usePopoverMenu();

  const handleViewDomainRecords = () => {
    analytics.track('Email Setup - View DNS records', {
      id: item.id,
      customerDomain: item.content.customerDomain,
    });
    onClose();
    openEmbedModal(item);
  };

  const handleSynchronizeStatus = () => {
    analytics.track('Email Setup - Check verification status', {
      id: item.id,
      customerDomain: item.content.customerDomain,
    });
    onClose();
    dispatch(emailDomainsResource.effects.verify(item));
  };

  const isEmailDomainValidated = item.content.state === EmailDomainState.ACTIVE;

  return (
    <OverflowMenu id={item.id} onClose={onClose} {...popoverMenuProps}>
      {!isEmailDomainValidated && (
        <OverflowMenuItem id="synchronize-status">
          <OverflowMenuButton data-aid="synchronize-status" type={Button} onClick={handleSynchronizeStatus}>
            Check verification status
          </OverflowMenuButton>
        </OverflowMenuItem>
      )}

      <OverflowMenuItem id="view-spf-and-dkim-values">
        <OverflowMenuButton data-aid="view-spf-and-dkim-values" type={Button} onClick={handleViewDomainRecords}>
          View SPF and DKIM values
        </OverflowMenuButton>
      </OverflowMenuItem>
    </OverflowMenu>
  );
};

export default EmailDomainRowActions;
